import { TimelineEvent } from '../types';

export const FETCH_TIMELINE_EVENTS_HISTORY_SUCCESS = 'FETCH_TIMELINE_EVENTS_HISTORY_SUCCESS';
export const TIMELINE_EVENTS_HISTORY_UPDATED = 'TIMELINE_EVENTS_HISTORY_UPDATED';
export const CLEAR_TIMELINE_EVENTS_HISTORY_ACTION = 'CLEAR_TIMELINE_EVENTS_HISTORY_ACTION';

export interface TimelineEventsHistoryResponse {
    events: TimelineEvent[];
    releaseId: string;
    appId: string;
    orgId: string;
}

export interface ClearTimelineEventsHistoryResponse {
    releaseId: string;
    appId: string;
    orgId: string;
}

export interface FetchTimelineEventsHistorySuccessAction {
    type: typeof FETCH_TIMELINE_EVENTS_HISTORY_SUCCESS;
    payload: TimelineEventsHistoryResponse;
}

export interface ClearTimelineEventsHistoryAction {
    type: typeof CLEAR_TIMELINE_EVENTS_HISTORY_ACTION;
    payload: ClearTimelineEventsHistoryResponse;
}

export const fetchTimelineEventsHistorySuccess: (
    payload: TimelineEventsHistoryResponse,
) => FetchTimelineEventsHistorySuccessAction = (payload) => {
    return {
        type: FETCH_TIMELINE_EVENTS_HISTORY_SUCCESS,
        payload,
    };
};

export const clearTimelineEventsHistoryAction: (
    payload: ClearTimelineEventsHistoryResponse,
) => ClearTimelineEventsHistoryAction = (payload) => {
    return {
        type: CLEAR_TIMELINE_EVENTS_HISTORY_ACTION,
        payload,
    };
};

export interface TimelineEventsHistoryUpdatedAction {
    type: typeof TIMELINE_EVENTS_HISTORY_UPDATED;
    payload: TimelineEventsHistoryResponse;
}

export const updateTimelineEventsHistory: (
    payload: TimelineEventsHistoryResponse,
) => TimelineEventsHistoryUpdatedAction = (payload) => {
    return {
        type: TIMELINE_EVENTS_HISTORY_UPDATED,
        payload,
    };
};
